import { hasOwnProperties } from 'helpers/utils'
import useProductVariant from 'hooks/useProductVariant'

const colourKeys = ['Colours', 'Colors']

function ProductVariant({ variants, options, updateCurrentVariant, currentVariant, updateUrl, displayType, isModal = false, hasOnlyDefaultVariant = false }) {
  const isOnlyVariantDefault = hasOnlyDefaultVariant || (variants.length === 1 && variants[0].title === 'Default Title')

  if (isOnlyVariantDefault) {
    return <></>
  }

  const { availableValues, selectableValues, selected, setSelected } = useProductVariant({ variants, options, updateCurrentVariant, currentVariant, updateUrl })

  return (
    <div className="flex flex-col text-sm">
      {Object.entries(availableValues).map(([key, values], index) => (
        <VariantGroup
          key={index}
          name={key}
          values={values}
          selected={selected}
          selectableValues={selectableValues}
          setSelected={setSelected}
          displayType={displayType}
          isModal={isModal}
        />
      ))}
    </div>
  )
}

function VariantGroup({ name, values, selected, selectableValues, setSelected, displayType, isModal }) {
  return (
    <div className={`mt-6 ${colourKeys.includes(name) ? 'order-first' : ''}`}>
      {displayType === 'dropdown' ? (
        <VariantDropdown items={values} option={name} selected={selected} selectableValues={selectableValues} setSelected={setSelected} />
      ) : (
        <>
          <div className="flex items-center gap-1 text-sm">
            <span className="mr-1 font-medium text-black">{name}</span>
            {hasOwnProperties(name, selected) && selected[name] && <div className="text-grey-700">{selected[name]}</div>}
          </div>
          <VariantList items={values} option={name} selected={selected} selectableValues={selectableValues} setSelected={setSelected} isModal={isModal} />
        </>
      )}
    </div>
  )
}

function VariantItem({ value, option, selected, selectableValues, setSelected, isModal }) {
  const onSelect = (value, option) => {
    selected = { ...selected, [option]: value }
    setSelected(selected)
  }

  const isSelected = hasOwnProperties(option, selected) && selected[option] === value

  const isDisabled = hasOwnProperties(option, selectableValues) && !selectableValues[option].includes(value)

  const isColour = colourKeys.includes(option)

  const getSwatchClass = (name) => {
    return `colour-swatch-${name.toLowerCase()}`
  }

  return (
    <>
      {!isColour ? (
        <button
          type="button"
          title={value}
          className={`flex h-10 items-center justify-center rounded-lg border p-2 text-center text-black ${isSelected && 'border-black'}`}
          name={value}
          onClick={() => onSelect(value, option)}
        >
          {value}
        </button>
      ) : (
        <button
          type="button"
          className={`relative mt-2 h-12 w-12 rounded-full border-[3px] border-white outline outline-1 outline-transparent ${getSwatchClass(value)} ${
            isSelected && 'outline-default'
          } ${isDisabled && 'before:absolute before:left-0 before:h-[1px] before:w-full before:rotate-[135deg] before:bg-white before:content-[""]'}`}
          name={value}
          onClick={() => onSelect(value, option)}
          title={getSwatchClass(value)}
          aria-label={getSwatchClass(value)}
        ></button>
      )}
    </>
  )
}

function VariantList({ items, option, selected, selectableValues, setSelected, isModal }) {
  return (
    <div className="mt-2 grid grid-cols-2 gap-4">
      {items.length &&
        items.map((item) => (
          <VariantItem value={item} option={option} selected={selected} selectableValues={selectableValues} setSelected={setSelected} isModal={isModal} />
        ))}
    </div>
  )
}

function VariantDropdown({ items, option, selected, selectableValues, setSelected }) {
  const onChange = (e) => {
    selected = { ...selected, [option]: e.target.value }
    setSelected(selected)
  }

  return (
    items.length && (
      <select onChange={onChange} className="input !py-2.5 !text-grey-700">
        {items.map((item) => (
          <option value={item} selected={selected[option] === item}>
            {item}
          </option>
        ))}
      </select>
    )
  )
}

export default ProductVariant
